<template>
    <div class="radio-yes-no">
        <label v-if="labelComputed" :for="id">{{ labelComputed }}</label>
        <AfValidationProvider v-slot="v"
                              :vid="vidComputed"
                              :disable-validation="disableValidation"
                              :name="labelComputed || ' '"
                              :rules="rules">
            <b-form-radio-group
                :id="inputId"
                v-model="localValue"
                :value-field="'id'"
                :options="options"
                :name="inputName"
                v-bind="$attrs"
                v-on="$listeners"
                :state="getValidationState(v)">
            </b-form-radio-group>
            <b-form-invalid-feedback :state="getValidationState(v)">
                {{ v.errors[0] }}
            </b-form-invalid-feedback>
        </AfValidationProvider>
    </div>
</template>

<script>
import input from "@/components/inputs/mixins/input";

export default {
    name: "RadioYesNo",
    mixins: [input],
    props: {
        options: {
            type: Array,
            default() {
                return [
                    {text: 'SI', id: true},
                    {text: 'NO', id: false},
                ]
            }
        }
    },
    data() {
        return {}
    }
}
</script>

<style lang="scss">

.radio-yes-no {
    padding: 0.6rem 0;
    display: flex;
    justify-content: space-between;

    > label {
        margin-right: 0.5rem;
        align-self: center;
        margin-bottom: 0;
    }

    .form-group {
        margin-bottom: 0;
    }

    > span {
        text-align: right;
    }

    .custom-control-inline:last-child {
        margin-right: 0;
    }
}

</style>
